import EmailIcon from '@assets/chanellsIcons/EmailIcon.svg'
import SmsIcon from '@assets/chanellsIcons/SmsIcon.svg'
import WhatsappIcon from '@assets/chanellsIcons/WhatsappIcon.svg'

export type NotificationChannelDisplay = {
  label: string
  icon: string | null
}

// Keyed by the Gateway's notification_channel_category_key, which both the
// consumer alerts and the alert messages endpoints send as the channel.
const CHANNELS: Record<string, NotificationChannelDisplay> = {
  sms: { label: 'SMS', icon: SmsIcon },
  email: { label: 'אימייל', icon: EmailIcon },
  whatsapp: { label: 'WhatsApp', icon: WhatsappIcon },
}

/** A channel the app does not know keeps the Gateway's name and has no icon. */
export const describeNotificationChannel = (
  channel: string
): NotificationChannelDisplay =>
  CHANNELS[channel.toLowerCase()] ?? { label: channel, icon: null }
